import React from "react";
import { Link } from "react-router-dom";

import { useCurrentCharacterName } from "../hooks/useCurrentCharacterName";

function getCharacterGivenName(characterName?: string) {
  if (!characterName) return "メイ";
  const normalized = characterName.replace(/\s+/g, " ").trim();
  if (!normalized) return "メイ";
  const parts = normalized.split(/[ ・･._-]+/).filter(Boolean);
  return parts.length > 1 ? parts[parts.length - 1] : parts[0];
}

function EntryCard({
  title,
  description,
  to,
}: {
  title: string;
  description: string;
  to: string;
}) {
  return (
    <Link
      to={to}
      className="block rounded-[2rem] border border-[#EADBC8] bg-white/90 p-6 shadow-[0_14px_34px_rgba(124,90,78,0.12)] transition hover:-translate-y-0.5 hover:bg-white"
    >
      <h2 className="text-xl font-black tracking-tight text-[#5D4D46]">{title}</h2>
      <p className="mt-2 text-sm leading-6 text-[#6B5851]">{description}</p>
      <p className="mt-5 text-sm font-black text-[#A67C52]">進む →</p>
    </Link>
  );
}

export default function TalkEntry() {
  const characterName = useCurrentCharacterName();
  const givenName = getCharacterGivenName(characterName);

  return (
    <main className="min-h-screen overflow-x-hidden bg-[radial-gradient(circle_at_top,_rgba(250,233,220,0.95),_rgba(255,249,245,1)_55%)] px-4 py-6 text-[#4A3E39] sm:px-6 sm:py-10">
      <div className="mx-auto w-full max-w-md">
        <header className="mb-6 flex items-center justify-between">
          <Link to="/home" className="text-sm font-bold text-[#A67C52] hover:text-[#7C5A4E]">
            ← 戻る
          </Link>
          <p className="text-sm font-bold tracking-tight text-[#7C5A4E]">{givenName}と話す</p>
          <Link to="/home" className="text-xs font-bold text-[#9C867D] hover:text-[#7C5A4E]">
            WizMate
          </Link>
        </header>

        <section className="rounded-[2.4rem] border border-white/80 bg-white/85 p-6 shadow-[0_24px_60px_rgba(124,90,78,0.16)] backdrop-blur-sm sm:p-7">
          <div>
            <p className="text-xs font-black uppercase tracking-[0.18em] text-[#A67C52]">Talk Modes</p>
            <h1 className="mt-3 text-3xl font-black tracking-tight text-[#7C5A4E]">話し方を選ぶ</h1>
          </div>

          <div className="mt-8 space-y-4">
            <EntryCard
              title="いつもの会話"
              description={`${givenName}と1対1で、いつもの会話を始めます。気軽な相談や雑談もこちらから入ります。`}
              to="/chat"
            />
            <EntryCard
              title="みんなで話す"
              description={`${givenName}を中心に、複数の会議メンバーと一緒に相談します。経営会議や士業相談もこちらから始めます。`}
              to="/talk/group"
            />
          </div>
        </section>
      </div>
    </main>
  );
}
